import { render, staticRenderFns } from "./PasswordSection.vue?vue&type=template&id=32ca905e"
import script from "./PasswordSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordSection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PasswordSection.vue?vue&type=style&index=0&id=32ca905e&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports